export default __webpack_public_path__ + "static/media/cy.f5a26825.svg";